module.exports = __webpack_public_path__ + "img/serviceNow.e10f0062.png";